import React, { useEffect, useRef } from 'react';
import { GUIA_BANNER_PLACEMENTS, captureGuiaBanner, guiaBannerUrl, guiaBannersEnabled } from '../lib/guiaBanner';

const LABEL = 'Guia MEEM na prática';
const link = 'font-semibold text-[var(--accent)] underline underline-offset-2 hover:text-[var(--accent-hover)]';

/**
 * Banner do guia pago. <aside> fora do conteúdo principal, sem animação, sem pop-up, escondido na impressão.
 * A visualização conta uma vez por montagem, com 50% visível por 1 s. Variantes: "faixa", "linha" e "menu".
 */
export default function GuiaBanner({ placement, variant = 'faixa', className = '' }) {
  const config = GUIA_BANNER_PLACEMENTS[placement];
  const ref = useRef(null);
  const enabled = guiaBannersEnabled();

  useEffect(() => {
    const el = ref.current;
    if (!enabled || !el || typeof IntersectionObserver === 'undefined') return undefined;
    let timer;
    let sent = false;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
        if (!timer && !sent) timer = window.setTimeout(() => { sent = true; captureGuiaBanner('guia_banner_viewed', placement); }, 1000);
      } else {
        window.clearTimeout(timer);
        timer = undefined;
      }
    }, { threshold: [0, 0.5, 1] });
    observer.observe(el);
    return () => { observer.disconnect(); window.clearTimeout(timer); };
  }, [enabled, placement]);

  if (!enabled || !config) return null;

  const anchor = (
    <a
      href={guiaBannerUrl(placement)}
      target="_blank"
      rel="noopener"
      data-guia-link={placement}
      onClick={() => captureGuiaBanner('guia_banner_clicked', placement)}
      className={variant === 'menu' ? className : link}
      ref={variant === 'menu' ? ref : undefined}
    >
      {config.cta}<span className="sr-only"> (abre em nova aba)</span>
    </a>
  );
  if (variant === 'menu') return anchor;

  const box = variant === 'linha'
    ? 'text-[length:var(--fs-14)]'
    : 'rounded-[8px] border border-[var(--line)] bg-[var(--hover)] px-4 py-3 text-[length:var(--fs-15)]';

  return (
    <aside ref={ref} aria-label={LABEL} data-guia-banner={placement} data-nosnippet className={`no-print text-[var(--ink-2)] ${box} ${className}`}>
      <p className="leading-snug">{config.texto} {anchor}</p>
    </aside>
  );
}
